import { render, staticRenderFns } from "./ShipmentInvoiceCountList.vue?vue&type=template&id=a0688d0a&scoped=true&"
import script from "./ShipmentInvoiceCountList.vue?vue&type=script&lang=js&"
export * from "./ShipmentInvoiceCountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0688d0a",
  null
  
)

export default component.exports